export const ONBOARDING_STATUS_LABELS = {
    setup: "Setup",
    training: "Treinamento",
    ready: "Pronto",
};

export const ONBOARDING_STATUS_COLORS = {
    setup: "warning",
    training: "accent",
    ready: "success",
};

export const DEFAULT_ONBOARDING_STEPS = [
    { id: 1, label: "Dados cadastrais cadastrados", checked: false },
    { id: 2, label: "Plano comercial definido", checked: false },
    { id: 3, label: "Usuários internos criados", checked: false },
    { id: 4, label: "Grade de turmas cadastradas", checked: false },
    { id: 5, label: "Alunos importados / cadastrados", checked: false },
    { id: 6, label: "Treinamento de equipe realizado", checked: false },
    { id: 7, label: "Primeira presença registrada", checked: false },
    { id: 8, label: "Primeira avaliação física lançada", checked: false },
];

export const getProgressPercentage = (steps) => {
    if (!steps || steps.length === 0) return 0;
    return Math.round((steps.filter(s => s.checked).length / steps.length) * 100);
};
